import { render } from "./privateServices.vue?vue&type=template&id=08a34416"
import script from "./privateServices.vue?vue&type=script&lang=js"
export * from "./privateServices.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__